import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Flex, Text} from '@chakra-ui/react'
import useOcapiSite from '../../hooks/useOcapiSite'
import ApplePay from '../apple-pay'
import useAdyenCheckout from '../../hooks/use-adyen-checkout'
import useApplePay from '../../hooks/use-apple-pay'

const APPLEPAY_METHOD = 'applepay'

const ExpressCheckout = ({containerProps}) => {
    const {cartEnabledExpressPayments} = useOcapiSite()
    const isApplePayEnabled = useMemo(
        () => Boolean(cartEnabledExpressPayments?.includes(APPLEPAY_METHOD)),
        [cartEnabledExpressPayments]
    )

    // check for active applePay
    const {checkout} = useAdyenCheckout({
        enabled: isApplePayEnabled,
        requiredMethod: APPLEPAY_METHOD
    })
    const {applePay} = useApplePay({checkout, enabled: isApplePayEnabled})

    // if no applePay is available, return null
    if (!applePay) {
        return null
    }

    return (
        <Flex flexDirection="column" alignItems="stretch" gap={2} {...containerProps}>
            <Text textStyle="Semi Bold Small">
                <FormattedMessage
                    defaultMessage="Express Checkout"
                    id="express-checkout.heading.express-checkout"
                />
            </Text>
            <ApplePay />
        </Flex>
    )
}

ExpressCheckout.propTypes = {
    containerProps: PropTypes.object
}

export default ExpressCheckout
